import React from 'react';
import { Icon, IconName } from 'react-frontier';

export interface DetailsListItem{
	id?: string | number,
	overline?: string,
	label: string,
	supporting?: string | React.ReactNode,
	trailing?: string,
	iconName?: IconName,
}

interface DetailsListProps{
	items: DetailsListItem[],
}

var DetailsList = (props: DetailsListProps)=>{
	return <div className="team-details-list">
		{props.items.map((item, index) => (
			<div key={item.id ?? `details-item-${index}`} className="team-details-item">
				{item.iconName && <div className="team-details-item-icon">
					<Icon name={item.iconName} size={20} />
				</div>}
				<div className="team-details-item-content">
					{item.overline && <div className="team-details-item-overline">{item.overline}</div>}
					<div className="team-details-item-label">{item.label}</div>
					{item.supporting && (
						typeof item.supporting === 'string'
							? <div className="team-details-item-supporting">{item.supporting}</div>
							: item.supporting
					)}
				</div>
				{item.trailing && <div className="team-details-item-trailing">{item.trailing}</div>}
			</div>
		))}
	</div>;
}

export default DetailsList;
